import { Module, ActionTree, MutationTree, GetterTree } from 'vuex'
const state = {
    isAllDecidable: true,
    questionList: [], // 所有试题树状数组（接口返回）
    submitQestionMap: {}, // 所有子题目数组 包含answer、judge、学生得分、每题总分、该题正确与否
    correctPercent: 0, // 正确率
    theDoingTaskObj: {}, // 当前正在操作的父子任务id
    queResList: [], // 所有试题的判题结果
    cardDetailQuery: {}, // 卡牌详情的查询参数
    skuDetailQuery: {}, // sku详情的查询参数
}

const mutations = {
  SET_QUSTION_LIST: (state, questionList) => {
    state.questionList = questionList
  },
  SET_ANSWER_MAP: (state, answerMap) => {
    state.answerMap = answerMap
  },
  SET_DATA: (state, [key, value]) => {
      state[key] = value
  }
}

const actions = {
  setQuestionList: ({ commit, state }, questionList) => {
    commit('SET_QUSTION_LIST', questionList)
  },
  setAnswerMap: ({ commit, state }, answerMap) => {
    commit('SET_ANSWER_MAP', answerMap)
  }
}
const getters = {
    questionList: (state) => state.questionList,
    correctPercent: (state) => state.correctPercent,
    submitQestionMap: (state) => state.submitQestionMap,
    theDoingTaskObj: (state) => state.theDoingTaskObj,
    queResList: (state) => state.queResList,
    isAllDecidable: (state) => state.isAllDecidable,
    cardDetailQuery: (state) => state.cardDetailQuery,
    skuDetailQuery: (state) => state.skuDetailQuery,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
